
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/atlas/roles-privacy-and-keys",
      function () {
        return require("private-next-pages/docs/atlas/roles-privacy-and-keys.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/atlas/roles-privacy-and-keys"])
      });
    }
  